import { Injectable } from '@angular/core';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { RestApiService } from './rest-api.service';
import { RestApiEndpoints } from '../enums/rest-api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerService {

  private vapidKey: string = 'BMk81x7duLATgTZIv8Xcucc_lMcL4vRifW2uq2wflhmOxH8u-hSBRz6-llSaRP_Qgw8gXxuv_zwx8PWXLCrsa-8';

  constructor(private swUpdate: SwUpdate,
    private swPush: SwPush,
    private restApiService: RestApiService) {


    /* PWA ServiceWorker implementation like described by angular. https://angular.io/guide/service-worker-communications */
    if (swUpdate.isEnabled) { /* Since some Browsers don't have any service worker capability, it's recommended by Angular to check if service workers are available before using them. */
      swUpdate.versionUpdates.subscribe(event => { /* If PWA is active (the browser supports service workers), the whole app gets cached localy, so we observe if the source code has changed on the server to be able to react on this changes. */
        switch (event.type) {
          case 'NO_NEW_VERSION_DETECTED': break;
          case 'VERSION_DETECTED':
            break;
          case 'VERSION_INSTALLATION_FAILED':
            break;
          case 'VERSION_READY':
            document.location.reload();
            break;
        }
      });

      swUpdate.unrecoverable.subscribe(event => { /* If something realy unrecoverable happens, the app needs to be reloaded. The user gets asked if he want's to reload in order to avoid infinite loops, also that the user can inform us about something went wrong. */
        if (confirm('Es ist ein Fehler aufgetreten, soll die Anwendung neu geladen werden?')) {
          document.location.reload();
        }
      });
    }

  }

  requestPushSubscription() {
    if (!this.swPush.isEnabled) { return; }

    this.swPush.requestSubscription({ serverPublicKey: this.vapidKey })
      .then(subscriptionObject => { this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.pushSubscription, subscriptionObject.toJSON()) })
      .catch(error => { /* I don't think we need to handle this because if no subscription is done, the User just won't receive push notifications. */ })
  }

}
